import React from "react";
import { useApp } from "../context/AppContext";
import { Menu, Bell, RefreshCw, Shield, Eye } from "lucide-react";

export default function Header({ onMenuToggle }) {
  const { state, dispatch } = useApp();
  const tabNames = { dashboard: "Dashboard", transactions: "Transactions", insights: "Insights" };

  return (
    <header className="h-14 border-b border-border bg-bg-secondary/80 backdrop-blur-sm flex items-center px-4 gap-4 sticky top-0 z-30">
      <button onClick={onMenuToggle}
        className="lg:hidden w-8 h-8 rounded-lg bg-bg-card border border-border flex items-center justify-center text-white/40 hover:text-white transition-colors">
        <Menu size={16} />
      </button>

      <div className="flex-1">
        <h2 className="font-display font-semibold text-white text-base">{tabNames[state.activeTab]}</h2>
      </div>

      <div className="flex items-center gap-2">
        <div className={`flex items-center gap-1.5 text-xs font-body px-3 py-1.5 rounded-lg border ${
          state.role === "admin"
            ? "bg-accent-gold/10 border-accent-gold/20 text-accent-gold"
            : "bg-accent-cyan/10 border-accent-cyan/20 text-accent-cyan"
        }`}>
          {state.role === "admin" ? <Shield size={12} /> : <Eye size={12} />}
          <span className="capitalize hidden sm:inline">{state.role}</span>
        </div>

        {state.role === "admin" && (
          <button onClick={() => dispatch({ type: "RESET_DATA" })}
            title="Reset to demo data"
            className="w-8 h-8 rounded-lg bg-bg-card border border-border flex items-center justify-center text-white/30 hover:text-white hover:border-white/20 transition-colors">
            <RefreshCw size={14} />
          </button>
        )}
      </div>
    </header>
  );
}
